let operationCount = 0
let wizardMounted = false

export const SuppressTreeBusy = {
    // Called when Zero U wizard tab mounts/unmounts
    setWizardMounted(mounted) {
        wizardMounted = mounted
    },
    // Called around individual update operations
    raise(suppress) {
        if (suppress) {
            operationCount++
        } else {
            operationCount = Math.max(0, operationCount - 1)
        }
    },
    isSuppressed() {
        // Suppress while wizard is mounted OR while operations are in progress
        return wizardMounted || operationCount > 0
    },
}
